import React from 'react';

interface LoadingProps {
  size: number;
}

export const Loading: React.FC<LoadingProps> = ({ size }) => {
  return (
    <div className="fixed left-0 top-0 flex h-full w-full items-center justify-center bg-appBG">
      <div
        style={{ width: `${size}px`, height: `${size}px` }}
        className="animate-spin"
      >
        <div
          className="h-full w-full rounded-[50%] border-4
       border-b-green-800 border-t-green-900"
        ></div>
      </div>
    </div>
  );
};
